<template>
    <CardPage :section="8" :page="3" :nextDisabled="nextDisabled">
        <v-scale-transition hide-on-leave>
            <div v-if="!selectedItem">
                <p>
                    Select a category and question to answer.
                </p>
                <p class="subheading text-xs-center">
                    Your Score: <span class="font-weight-bold">{{ score | number }}</span>
                </p>
                <div v-for="(category, index) in categories" :key="index">
                    <p class="text-xs-center primary--text font-weight-bold mb-1">
                        {{ category }}
                    </p>
                    <v-container fluid grid-list-xs>
                        <v-layout row wrap>
                            <v-flex v-for="(key, index) in gameOrder" :key="index" xs3 @click="select(game[key])" v-ripple>
                                <div class="card fill-height" v-if="game[key].category === category">
                                    <v-layout column fill-height align-center justify-center>
                                        <div>{{ game[key].points }}</div>
                                    </v-layout>
                                    <div class="check" v-if="game[key].answer.length && game[key].correctAnswer === game[key].answer">
                                        <v-avatar size="32" class="success">
                                            <v-icon dark>check</v-icon>
                                        </v-avatar>
                                    </div>
                                    <div class="check" v-if="game[key].answer.length && game[key].correctAnswer !== game[key].answer">
                                        <v-avatar size="32" class="error">
                                            <v-icon dark>close</v-icon>
                                        </v-avatar>
                                    </div>
                                </div>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </div>
                <p class="font-weight-bold" v-if="allAnswered && score !== maxScore">
                    If you’d like to try and improve your score click on any category again to try again!
                </p>
            </div>
        </v-scale-transition>
        <v-scale-transition hide-on-leave>
            <div v-if="selectedItem">
                <v-fade-transition hide-on-leave>
                    <div v-if="!selectedItemAnswered">
                        <p class="text-xs-center font-weight-bold mb-1">{{ selectedItem.category }} {{ selectedItem.points }}</p>
                        <p>
                            {{ selectedItem.question }}
                        </p>
                    </div>
                </v-fade-transition>
                <v-fade-transition hide-on-leave>
                    <div v-if="selectedItemAnswered">
                        <v-container fluid grid-list-xs>
                            <v-layout row wrap align-center mx-3>
                                <v-spacer></v-spacer>
                                <v-flex xs5>
                                    <v-container
                                        fill-height
                                        class="text-xs-center font-weight-bold white--text block-button"
                                        :class="{
                                            success: selectedItem.correctAnswer === selectedItem.answer,
                                            error: selectedItem.correctAnswer !== selectedItem.answer
                                        }"
                                    >
                                        <v-layout row wrap align-center>
                                            <v-flex>
                                                <v-icon dark v-if="selectedItem.correctAnswer === selectedItem.answer">thumb_up</v-icon>
                                                <v-icon dark v-else>thumb_down</v-icon>
                                                <div class="text-capitalize">{{ selectedItem.correctAnswer }}</div>
                                            </v-flex>
                                        </v-layout>
                                    </v-container>
                                </v-flex>
                                <v-spacer></v-spacer>
                            </v-layout>
                        </v-container>
                        <p v-html="selectedItem.blurb"></p>
                    </div>
                </v-fade-transition>
            </div>
        </v-scale-transition>
        <template v-if="selectedItem" v-slot:actions>
            <v-spacer></v-spacer>
            <v-btn round color="primary" @click="answer('true')" v-if="!selectedItemAnswered">True</v-btn>
            <v-btn round color="primary" @click="answer('false')" v-if="!selectedItemAnswered">False</v-btn>
            <v-btn round color="primary" @click="done()" v-if="selectedItemAnswered">Got It</v-btn>
            <v-spacer></v-spacer>
        </template>
    </CardPage>
</template>

<script>
import { get } from 'vuex-pathify';

const MIN_SCORE = 1000;

export default {
    data() {
        return {
            selectedItem: null,
            selectedItemAnswered: false
        };
    },
    computed: {
        categories: get('section8/categories'),
        allAnswered: get('section8/allAnswered'),
        game: get('section8/game'),
        gameOrder: get('section8/gameOrder'),
        score: get('section8/score'),
        maxScore: get('section8/maxScore')
    },
    methods: {
        select(gameItem) {
            this.selectedItem = gameItem;
            this.selectedItemAnswered = false;
        },
        answer(response) {
            this.$store.set(`section8/game@${this.selectedItem.id}.answer`, response);
            this.selectedItemAnswered = true;
        },
        done() {
            this.selectedItem = null;
            this.selectedItemAnswered = false;
        },
        nextDisabled() {
            return this.score < MIN_SCORE;
        }
    }
};
</script>

<style scoped>
.card {
    min-height: 100px;
    position: relative;
    font-size: 150%;
    font-weight: bold;
    color: #fff;
    background-color: #0033ca;
}
.check {
    position: absolute;
    bottom: 0;
    right: 0;
    transform: translate(0%, 0%);
}
.correct {
    opacity: 0.5;
}
</style>
